import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { SubcategoriesService } from '../subcategories.service';
import { SubcategoriesAddPayload, SubcategoriesEditPayload } from '../subcategories.interface';
import { CategoriesService } from '../../categories/categories.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-edit-subcategories',
    templateUrl: './edit-subcategories.component.html',
    styleUrls: ['./edit-subcategories.component.scss']
})
export class EditSubcategoriesComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    categorii$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        title: new FormControl(this.data.title, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        description: new FormControl(this.data.description, [Validators.required]),
        id_category: new FormControl(this.data.id_category, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditSubcategoriesComponent>,
        private requestService: SubcategoriesService,
        private categoriesService: CategoriesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadCategoriesActive();
    }

    loadCategoriesActive() {
        this.isLoading = true;
        this.categorii$ = this.categoriesService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    submitForm() {
        this.isLoading = true;

        const { title, slug, description, id_category } = this.form
            .value as SubcategoriesAddPayload;
        const payload: SubcategoriesEditPayload = {
            id: this.data.id,
            title,
            slug,
            description,
            id_category
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
